import { profile } from 'pages/locations'


export default [
  //profile
  { path: '/locations/:id/profile', name: 'locations.profile', component: profile
    , meta:{permits:['location_profile']}},
]
